import { render, staticRenderFns } from "./modalViewAccountBank.vue?vue&type=template&id=5c19466d"
import script from "./modalViewAccountBank.vue?vue&type=script&lang=js"
export * from "./modalViewAccountBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports